// Local category artwork served from the Go backend's static folder.
// Filenames include spaces (e.g. "RTW Saree.png"), so we encode at module load.
const BE = process.env.REACT_APP_BACKEND_URL || '';

const RAW_MAP = {
  blouse: 'Blouse.webp',
  kurti: 'Kurta.webp',
  suit: 'Suit.webp',
  lehenga: 'Lahenga.webp',
  'ready-to-wear-saree': 'RTW Saree.webp',
  skirt: 'Western_Skirts.webp',
  dress: 'Dress.webp',
  top: 'Tops.webp',
  'co-ord-set': 'Co-ord_Sets.webp',
  pant: 'Trouser.webp',
  others: 'Others.webp',
};

const CATEGORY_IMAGE_MAP = Object.fromEntries(
  Object.entries(RAW_MAP).map(([slug, file]) => [slug, `${BE}/api/static/category-banners/${encodeURIComponent(file)}`])
);

export function getCategoryImage(category) {
  if (category?.image) {
    return category.image.startsWith('/api') ? `${BE}${category.image}` : category.image;
  }
  return CATEGORY_IMAGE_MAP[category?.slug] || '';
}

export const HERO_BANNERS = [
  { image: `${BE}/api/static/hero-banners/Hero_Banner_1.png`, title: 'Bespoke Tailoring,\nCrafted for You', subtitle: 'Premium custom stitching with perfect fit guaranteed' },
  { image: `${BE}/api/static/hero-banners/Hero_Banner_2.png`, title: 'Your Design,\nOur Expertise', subtitle: 'Choose your style or upload your own design' },
  { image: `${BE}/api/static/hero-banners/Hero_Banner_3.png`, title: 'Delivered with\nPerfection', subtitle: 'Expert craftsmanship delivered to your doorstep' },
  { image: `${BE}/api/static/hero-banners/Hero_Banner_4.png`, title: 'Style that\nFits Your Story', subtitle: 'A signature look, tailored just for you' },
];
